import { Avatar, Box, Grid, Typography, useTheme } from '@mui/material'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { TechnologySelectors } from '../../../../../../../../store/technology'
import { formatPhoneNumber } from '../../../../../../../../utils'

interface ProjectMemberDetailModalProps {
  memberId: string
}

export const ProjectMemberDetail: FC<ProjectMemberDetailModalProps> = ({
                                                                           memberId,
}) => {
  const theme = useTheme()

  const member = useSelector((state) => TechnologySelectors.makeTechnologyMember(state, memberId))

  return (
    <Box>
      <Typography color="secondary" fontWeight={700} fontSize="1.3rem">
        Member Detail
      </Typography>

      {member && (
        <Grid container mt={2}>
          <Grid container item xs={2} mr={1}>
            <Avatar sx={{ width: 60, height: 60, background: '#E2E2E2' }} src={member.avatar}>
              {member.firstName[0]}
            </Avatar>
          </Grid>

          <Grid item container xs={9} spacing={2}>
            <Grid item xs={12}>
              <Typography fontSize="0.875rem" fontWeight={500} color="secondary.light">
                Full name
              </Typography>
              <Typography
                fontSize="0.9rem"
                fontWeight={700}
                color="secondary"
              >{`${member.firstName} ${member.lastName}`}</Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography
                fontSize="0.875rem"
                fontWeight={theme.typography.fontWeightMedium}
                color="secondary.light"
              >
                Email
              </Typography>
              <Typography
                fontSize="0.9rem"
                fontWeight={theme.typography.fontWeightBold}
                color="secondary"
              >
                {member.email}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography
                fontSize="0.875rem"
                fontWeight={theme.typography.fontWeightMedium}
                color="secondary.light"
              >
                Phone
              </Typography>
              <Typography
                fontSize="0.9rem"
                fontWeight={theme.typography.fontWeightBold}
                color="secondary"
              >
                {formatPhoneNumber(member.phone) || '-'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Box>
  )
}
